import type { JSX } from "react"
import { Link, useNavigate } from "react-router-dom"

import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  //   DropdownMenuLabel,
  //   DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"

import { Login } from "../auth/Login"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { logout } from "../auth/authSlice"
import { resetHome } from "../home/homeSlice"
import TextType from "@/components/TextType"

export const Header = (): JSX.Element | null => {
  const authSlice = useAppSelector(state => state.auth)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  return (
    <header className="flex items-center justify-between px-8 py-4">
      <Tooltip>
        <TooltipTrigger className="">
          <Link to="/" onClick={() => dispatch(resetHome())}>
            <Button className="text-xl cursor-pointer" variant="ghost">
              {/* nativefingers(β) */}
              <TextType
                text={["nativefingers(β)", "learning through muscle memory"]}
                typingSpeed={75}
                pauseDuration={5000}
                showCursor={true}
                cursorCharacter="_"
              />
            </Button>
          </Link>
        </TooltipTrigger>
        <TooltipContent>currently in beta!</TooltipContent>
      </Tooltip>
      <div className="hidden md:flex gap-4">
        <Link to="/" onClick={() => dispatch(resetHome())}>
          <Button className="text-base cursor-pointer" variant="ghost">
            home
          </Button>
        </Link>
        <Link to="/leaderboards">
          <Button className="text-base cursor-pointer" variant="ghost">
            leaderboards
          </Button>
        </Link>
        <Dialog>
          <DialogTrigger asChild>
            <Button className="text-base cursor-pointer" variant="ghost">
              about
            </Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader>
              <DialogTitle>about nativefingers</DialogTitle>
              <DialogDescription asChild>
                <div>
                  nativefingers began as a university group project.
                  <br />
                  <br />
                  The idea was to harness the power of muscle memory through typing to strengthen your vocabulary and
                  spelling skills. Just like your fingers eventually nail a guitar solo after enough practice, they can
                  learn to recognize words and spellings on instinct.
                  <br />
                  <br />
                  nativefingers isn't meant to replace your favorite language app, but to support it one keystroke at a
                  time. And if you touch type? That's when the real magic kicks in.
                  <br />
                  <br />
                  Happy typing.
                  <div className="flex flex-wrap justify-center mt-4">
                    {/* <TooltipProvider> */}
                    <Tooltip>
                      <TooltipTrigger className="mx-auto mt-4">
                        <img src="/docker.png" alt="docker" className="w-10" />
                      </TooltipTrigger>
                      <TooltipContent>docker</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                      <TooltipTrigger className="mx-auto mt-4">
                        <img src="/express.png" alt="express" className="w-16" />
                      </TooltipTrigger>
                      <TooltipContent>express</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                      <TooltipTrigger className="mx-auto mt-4">
                        <img src="/postgresql.png" alt="postgresql" className="w-10" />
                      </TooltipTrigger>
                      <TooltipContent>postgresql</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                      <TooltipTrigger className="mx-auto mt-4">
                        <img src="/react.png" alt="react" className="w-10" />
                      </TooltipTrigger>
                      <TooltipContent>react</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                      <TooltipTrigger className="mx-auto mt-4">
                        <img src="/redux.png" alt="redux" className="w-10" />
                      </TooltipTrigger>
                      <TooltipContent>redux</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                      <TooltipTrigger className="mx-auto mt-4">
                        <img src="/tailwind.webp" alt="tailwind" className="w-10" />
                      </TooltipTrigger>
                      <TooltipContent>tailwind</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                      <TooltipTrigger className="mx-auto mt-4">
                        <img src="/ts.png" alt="typescript" className="w-10" />
                      </TooltipTrigger>
                      <TooltipContent>typescript</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                      <TooltipTrigger className="mx-auto mt-4">
                        <img src="/vite.svg" alt="vite" className="w-10" />
                      </TooltipTrigger>
                      <TooltipContent>vite</TooltipContent>
                    </Tooltip>
                    {/* </TooltipProvider> */}
                  </div>
                </div>
              </DialogDescription>
            </DialogHeader>
          </DialogContent>
        </Dialog>
        {/* <Button variant="ghost">Profile</Button> */}
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button className="text-base cursor-pointer" variant="ghost">
              {authSlice.token ? "profile" : "login"}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {/* <DropdownMenuItem>Log In</DropdownMenuItem>
            <DropdownMenuItem>Log Out</DropdownMenuItem>
            <DropdownMenuItem>View Profile</DropdownMenuItem> */}
            {authSlice.token ? (
              <>
                <DropdownMenuItem>
                  <Link to="/user">view profile</Link>
                </DropdownMenuItem>
                <DropdownMenuItem
                  onClick={() => {
                    dispatch(logout())
                    // window.location.href = "/"
                    void navigate("/")
                  }}
                >
                  log out
                </DropdownMenuItem>
              </>
            ) : (
              <DropdownMenuItem>
                <Login />
              </DropdownMenuItem>
            )}
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      {/* <Sheet>
        <SheetTrigger className="md:hidden">
          <Button variant="outline">Menu</Button>
        </SheetTrigger>
        <SheetContent>
          <div className="flex flex-col gap-4 mt-8">
            <Button variant="ghost">Home</Button>
            <Button variant="ghost">About</Button>
            <Button variant="ghost">Contact</Button>
          </div>
        </SheetContent>
      </Sheet> */}
    </header>
  )
}
